<template>
  <div class="content">
    <h3 class="title">{{ $t('meta.baseData') }}</h3>
    <div class="data">
      <div>
        <span class="label">{{ $t('orderDetail.site') }}</span>
        <Link :to="`/company/sites/${order.site.uuid}`">
          {{ order.site.name }}
        </Link>
      </div>
      <div v-if="order.full_container">
        <span class="label">{{ $t('orderDetail.fullContainer') }}</span>
        <Link :to="`/company/containers/${order.full_container.uuid}`">
          {{ order.full_container.name }}
        </Link>
      </div>
      <div v-if="order.empty_container">
        <span class="label">{{ $t('orderDetail.emptyContainer') }}</span>
        <Link :to="`/company/containers/${order.empty_container.uuid}`">
          {{ order.empty_container.name }}
        </Link>
      </div>
      <div v-if="order.comment">
        <span class="label">{{ $t('orderDetail.comment') }}</span>
        {{ order.comment }}
      </div>
      <div v-if="order.target_zone">
        <span class="label">{{ $t('orderDetail.targetZone') }}</span>
        {{ order.target_zone.name }}
      </div>
      <div v-if="order.fraction">
        <span class="label">{{ $t('orderDetail.fraction') }}</span>
        {{ order.fraction.localized_name }}
      </div>
    </div>
    <h3 class="title">{{ $t('action.actions') }}</h3>
    <div class="actions">
      <div class="data" v-for="{ action, count } in groupedActions" :key="action.uuid">
        <ActionIcon :action="action" />

        <b v-if="count > 1" style="">{{ count }} ×</b>

        <div v-if="action.comment_text">
          {{ action.comment_text }}
        </div>

        <div v-if="action.zone_name">
          <span class="label">{{ $t('action.zone') }}</span>
          {{ action.zone_name }}
        </div>

        <div v-if="action.zone_2_name">
          <span class="label">{{ $t('action.zone') }}</span>
          {{ action.zone_2_name }}
        </div>

        <div v-if="action.container_name">
          <span class="label">{{ $t('action.container') }}</span>
          {{ action.container_name }}
        </div>

        <div v-if="action.action_name == 'weigh_and_empty'">
          <span class="label">{{ $t('orderDetail.weight') }}</span>
          {{ order.material_weight_kg }}kg
        </div>
      </div>
      <div v-if="order.actions.length == 0">-</div>
    </div>
  </div>
</template>

<script>
import ActionIcon from '@/components/ActionIcon/index.vue'

export default {
  components: { ActionIcon },
  props: { order: { type: Object, required: true } },

  computed: {
    // This functions groups similar Actions. At the moment,
    // this is only for pickup Actions in GatheringPickupOrders
    // but it will also be relevant for the empty Action in
    // GatheringOrders later.
    //
    // Groups look like this:
    //   [{action: {…}, count: 1}, …]
    groupedActions() {
      const self = this
      const groups = []
      let currentGroup = null

      this.order.actions.forEach(function (action) {
        if (action.action_name === 'empty' || action.action_name === 'pickup') {
          if (currentGroup) {
            if (self.groupable(action, currentGroup)) {
              groups[groups.length - 1].count += 1
            } else {
              currentGroup = action
              groups.push({ action: action, count: 1 })
            }
          } else {
            currentGroup = action
            groups.push({ action: action, count: 1 })
          }
        } else {
          currentGroup = null
          groups.push({ action: action, count: 1 })
        }
      })

      return groups
    },
  },
  methods: {
    groupable(left, right) {
      const timeDiffSeconds = Math.abs(Date.parse(left.created_at) - Date.parse(right.created_at)) / 1000

      return (
        left.action_name == right.action_name &&
        left.container_uuid == right.container_uuid &&
        left.zone_uuid == right.zone_uuid &&
        left.zone_2_uuid == right.zone_2_uuid &&
        timeDiffSeconds <= 5
      )
    },
  },
}
</script>

<style scoped>
.data {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 9px;
}

.title {
  margin: 0 0 5px;

  &:not(:first-child) {
    margin-top: 10px;
  }
}

.label::after {
  content: ':';
}
</style>
